import React, { useRef } from 'react'

import { useTranslation } from 'react-i18next'

import { Button, ButtonRef } from 'devextreme-react/button'
import { Popup } from 'devextreme-react/popup'
import ScrollView from 'devextreme-react/scroll-view'

import './confirm-popup.scss'

export interface IIxConfirmPopupProps {
    popupVisible: boolean,
    title: string,
    description: string,

    cancel?: string,
    confirm?: string,

    onConfirm?: () => void,
    onHiding: () => void,
}
export const IxConfirmPopup = ({ popupVisible, title, description, cancel, confirm, onConfirm, onHiding }: IIxConfirmPopupProps) => {
    const { t } = useTranslation()
    const cancelButton: any = useRef<ButtonRef>()


    return (
        <Popup
            visible={popupVisible}
            // onHiding={onHiding}
            showTitle={true}
            title={title}
            showCloseButton={false}
            width={300}
            height='auto'
            className='confirm-popup'
            onShown={() => {cancelButton.current?.instance().focus()}}
        >
            <div className='confirm-popup--content'>
                <ScrollView direction='both'>
                    <p style={ { marginTop: '0.25rem' } }>{description}</p>
                </ScrollView>
                    {
                        onConfirm ? (
                            <div className='confirm-popup--btns'>
                                <Button text={confirm || t('global:button.ok')} type='default' stylingMode='contained' onClick={onConfirm} />
                                <Button ref={cancelButton} text={cancel || t('global:button.cancel')} type='normal' stylingMode='contained' onClick={onHiding} />
                            </div>
                        ) : (
                            <div className='confirm-popup--btns'>
                                <Button ref={cancelButton} text={t('global:button.ok')} type='default' stylingMode='contained' onClick={onHiding} />
                            </div>
                        )
                    }
            </div>
        </Popup>
    )
}
